import { VerifSubDomain } from './verifSubdomain'

const SUBDOMAIN_STORAGE_KEY = '@Subdominio:BetBuilder'

export const normalizeSubdomain = (value) => {
  if (typeof value !== 'string') {
    return ''
  }

  const normalized = value.trim().toLowerCase()
  if (!normalized || normalized === 'undefined' || normalized === 'null') {
    return ''
  }

  return normalized
}

export const resolveSubdomain = () => {
  const fallback = 'playcomgg'

  try {
    const storedValue = normalizeSubdomain(localStorage.getItem(SUBDOMAIN_STORAGE_KEY))
    if (storedValue) {
      return storedValue
    }
  } catch (error) {
    // localStorage pode nao estar disponivel durante testes.
  }

  const detected = normalizeSubdomain(VerifSubDomain())

  if (!detected) {
    return fallback
  }

  try {
    localStorage.setItem(SUBDOMAIN_STORAGE_KEY, detected)
  } catch (error) {
    // Ignora erros de persistencia sem bloquear o fluxo.
  }

  return detected
}

export const withSubdomainQuery = (url, subdomain = resolveSubdomain()) => {
  const normalized = normalizeSubdomain(subdomain)

  if (!normalized || /[?&]subdomain=/i.test(url)) {
    return url
  }

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}subdomain=${encodeURIComponent(normalized)}`
}
